import ShiftPatternList from '@/controllers/shift_pattern/shift-pattern-list.js';

export default {
  extends: ShiftPatternList,
}
